import React from 'react';
import { ComponentHeaderRightSideOptions } from '../../../Components/Form/Inputs/ComponentMoreOptionsHorizontalDots';
import Table from '../../../Components/Tables/Table/Table';
import { CommodityOtcPriceCompositeModel } from '../../Futures/Otc/OtcPricesTableDefinitions';
import { SymbolContractCompositeModel } from '../../Futures/Prices/FuturesPricesTableDefinitions';
import { PhysicalPricesCompositeModel } from '../../PhysicalPrices/PhysicalPricesPageDefinitions';
import DashboardNonChartWrapper from '../DashboardNonChartWrapper';
import {
    dashboardFuturesPricesTableDefinitions,
    dashboardOtcPricesTableDefinitions,
    dashboardPhysicalPricesTableDefinitions,
} from './DashboardTableDefinitions';

interface IDashboardTableBaseProps {
    customTitle?: string;
    title?: string;
    dragIndicatorIcon?: React.ReactNode;
    isInDashboardEditMode?: boolean;
    maximizeMinimizeButton?: ComponentHeaderRightSideOptions.Maximize | ComponentHeaderRightSideOptions.Minimize;
    useDynamicHeight?: boolean;
    handleMoreOptionsSelection?: (value: ComponentHeaderRightSideOptions) => void;
}

type DashboardTableVariant =
    | { tableType: 'futures'; tableData: SymbolContractCompositeModel[] }
    | { tableType: 'otc'; tableData: CommodityOtcPriceCompositeModel[] }
    | { tableType: 'physical'; tableData: PhysicalPricesCompositeModel[] };

export type IDashboardPricesTableProps = IDashboardTableBaseProps & DashboardTableVariant;

const renderTable = (props: IDashboardPricesTableProps): JSX.Element => {
    switch (props.tableType) {
        case 'futures':
            return <Table tableHeaders={dashboardFuturesPricesTableDefinitions} tableData={props.tableData} isScrollable isColumnOrderingEnabled />;
        case 'otc':
            return <Table tableHeaders={dashboardOtcPricesTableDefinitions} tableData={props.tableData} isScrollable isColumnOrderingEnabled />;
        case 'physical':
            return <Table tableHeaders={dashboardPhysicalPricesTableDefinitions} tableData={props.tableData} isScrollable isColumnOrderingEnabled />;
        default:
            return <> </>;
    }
};

export const DashboardPricesTable: React.FC<IDashboardPricesTableProps> = (props) => (
    <DashboardNonChartWrapper
        customTitle={props.customTitle}
        dragIndicatorIcon={props.dragIndicatorIcon}
        isInDashboardEditMode={props.isInDashboardEditMode}
        maximizeMinimizeButton={props.maximizeMinimizeButton}
        name="DashboardPricesTable"
        title={props.title}
        useDynamicHeight={props.useDynamicHeight}
        handleMoreOptionsSelection={props.handleMoreOptionsSelection ?? (() => {})}
    >
        {renderTable(props)}
    </DashboardNonChartWrapper>
);
